import React from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { VideoIcon, ArrowRightIcon } from '@fiverr-private/visuals';
import { getLocalizedPriceByCurrency } from '../../utils';

interface ConsultationButtonItemProps {
  price: number;
  currency: object;
}

export const ConsultationButtonItem: React.FC<ConsultationButtonItemProps> = ({ price, currency }) => {
  const bookConsultationCopy = translate('consultation.book_consultation_item.title');
  const descriptionCopy = translate('consultation.book_consultation_item.description');

  const getLocalizedPrice = getLocalizedPriceByCurrency(currency);
  const formattedPrice = getLocalizedPrice(price);

  return (
    <Button variant="ghost" fullWidth>
      <Stack alignItems="center" padding="0" justifyContent="spaceBetween" flex="1" width="100%">
        <Stack gap="4" alignItems="center" flex="1" width="100%">
          <Center as="span" backgroundColor="grey_300" height={42} width={42} flexShrink={0} borderRadius="circle">
            <VideoIcon />
          </Center>
          <Stack direction="column" gap="0" textAlign="start" width="100%" whiteSpace="preWrap">
            <Text fontWeight="semibold">{bookConsultationCopy}</Text>
            <Text color="bodySecondary" size="b_sm">
              {descriptionCopy}
            </Text>
          </Stack>
        </Stack>

        <Stack gap="2" alignItems="center" flex="0" width="100%">
          <Text fontWeight="semibold" size="b_sm">
            {formattedPrice}
          </Text>
          <ArrowRightIcon />
        </Stack>
      </Stack>
    </Button>
  );
};
